import { render, staticRenderFns } from "./MobileMessageItem.vue?vue&type=template&id=743d448a&"
import script from "./MobileMessageItem.vue?vue&type=script&lang=ts&"
export * from "./MobileMessageItem.vue?vue&type=script&lang=ts&"
import style0 from "./MobileMessageItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports